import {
    HttpB2cList,
    HttpCancelOrder,
    HttpResetOrder,
    HttpRecoveryNormal,

    HttptoExamine,
    HttpPushFbb,
    HttpComuteCosts,
    HttpChangeOrder,
    HttpAddorderSign,
    HttpCloseOrder,
    HttpDownSurFaceOrder,
    HttpCheckOtherOrder,
} from '@/service/boss/b2corder'
import comAbnomal from '../alert/abnomal'
import compSendTime from '../alert/sendtime'
export default {
    components: {
        comAbnomal,
        compSendTime
    },
    computed: {
        getOperateRequestMap () {
            return (type, id) => {
                let map = 
                {
                    // 'removeexcept': {
                    //     request: HttpRecoveryNormal,
                    //     params: { orderIds: id, recoveryNormal: 0 },
                    //     title: this.$t(
                    //         "erp.b2c.back_normal_onlyremove",
                    //         { defaultValue: "恢复正常 (仅去除异常)" }
                    //     ),
                    //     desc: this.$t("erp.b2c.backnormal_onlyremovedesc", {
                    //         defaultValue:
                    //             "该操作仅去除订单的异常类型，不会进入订单自动处理流程",
                    //     })
                    // },
                    'cancel': {
                        request: HttpCancelOrder,
                        params: { orderId: id }
                    },
                    // 重置订单
                    'resetorder': {
                        request: HttpResetOrder,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id }
                    },
                    // 恢复正常
                    'backnormal': {
                        request: HttpRecoveryNormal,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id,recoveryNormal:1},
                        title: this.$t('erp.b2c.back_normal',{defaultValue:'恢复正常'}),
                        desc: this.$t('erp.b2c.backnormal_desc',{defaultValue:'确定要将订单恢复为正常处理的订单？'}),
                    },
                    'project': {},
                    // 审核通过
                    'passapprove': {
                        request: HttptoExamine,
                        params:{ orderIds: Array.isArray(id) ? id.join(',') : id }
                    },
                    // 推送云仓
                    'forcedpush': {
                        request: HttpPushFbb,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, node:1 }
                    },
                    // 修改订单类型-正常销售
                    'normalsales': {
                        title: this.$t('erp.b2c.modify_order',{defaultValue:'修改订单类型'}),
                        desc: this.$t('erp.b2c.modifyorder_type',{defaultValue:'确定修改订单类型为正常销售？'}),
                        request: HttpChangeOrder,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, orderType:0 }
                    },
                    // 修改订单类型-展示订单
                    'displayorder': {
                        title: this.$t('erp.b2c.modify_order',{defaultValue:'修改订单类型'}),
                        desc: this.$t('erp.b2c.diaplayor_order',{defaultValue:'确定修改订单类型为展示订单？'}),
                        request: HttpChangeOrder,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, orderType:1 }
                    },
                    // 修改订单类型-分销订单
                    'distributeorder': {
                        title: this.$t('erp.b2c.modify_order',{defaultValue:'修改订单类型'}),
                        desc: this.$t('erp.b2c.distribute_order',{defaultValue:'确定修改订单类型为分销订单？'}),
                        request: HttpChangeOrder,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, orderType:2 }
                    },
                    // 修改订单类型-刷评订单
                    'revieworder': {
                        title: this.$t('erp.b2c.modify_order',{defaultValue:'修改订单类型'}),
                        desc: this.$t('erp.b2c.review_order',{defaultValue:'确定修改订单类型为刷评订单？'}),
                        request: HttpChangeOrder,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, orderType:3}
                    },
                    // 修改订单类型-发货订单
                    'deliveryOrder': {
                        title: this.$t('erp.b2c.modify_order',{defaultValue:'修改订单类型'}),
                        desc: this.$t('erp.b2c.delivery_order',{defaultValue:'确定修改订单类型为发货订单？'}),
                        request: HttpChangeOrder,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, orderType:4}
                    },
                    'disassembleorder': {
                        title: this.$t('erp.b2c.add_ordermark',{defaultValue:'增加订单标记'}),
                        desc: this.$t('erp.b2c.disassembleorder_desc',{defaultValue:'确定为订单增加一个订单标记为拆解订单？'}),
                        request: HttpAddorderSign,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, orderSign:5 }
                    },
                    'additionalorder': {
                        title: this.$t('erp.b2c.add_ordermark',{defaultValue:'增加订单标记'}),
                        desc: this.$t('erp.b2c.additional_desc',{defaultValue:'确定为订单增加一个订单标记为附加订单？'}),
                        request: HttpAddorderSign,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, orderSign:4 }
                    },
                    // 增加订单标记-补发订单
                    'reissueorder': {
                        title: this.$t('erp.b2c.add_ordermark',{defaultValue:'增加订单标记'}),
                        desc: this.$t('erp.b2c.replacementorder_desc',{defaultValue:'确定为订单增加一个订单标记为补发订单？'}),
                        request: HttpAddorderSign,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, orderSign:3 }
                    },
                    // 增加订单标记-红人订单
                    'redpeopleorder': {
                        title: this.$t('erp.b2c.add_ordermark',{defaultValue:'增加订单标记'}),
                        desc: this.$t('erp.b2c.redpeople_desc',{defaultValue:'确定为订单增加一个订单标记为红人订单？'}),
                        request: HttpAddorderSign,
                        params:  { orderIds: Array.isArray(id) ? id.join(',') : id, orderSign:1 }
                    },
                    // 增加订单标记-样品订单
                    'sampleorder': {
                        title: this.$t('erp.b2c.add_ordermark',{defaultValue:'增加订单标记'}),
                        desc: this.$t('erp.b2c.sampleorder_desc',{defaultValue:'确定为订单增加一个订单标记为样品订单？'}),
                        request: HttpAddorderSign,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, orderSign:2 }
                    },
                    // 手动关闭
                    'handerclose': {
                        request: HttpCloseOrder,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id }
                    },
                    // 恢复正常(仅去除异常)
                    'removeexcept': {
                        title: this.$t(
                            "erp.b2c.back_normal_onlyremove",
                            { defaultValue: "恢复正常 (仅去除异常)" }
                        ),
                        desc: this.$t("erp.b2c.backnormal_onlyremovedesc", {
                            defaultValue:
                                "该操作仅去除订单的异常类型，不会进入订单自动处理流程",
                        }),
                        request: HttpRecoveryNormal,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, recoveryNormal: 0 }
                    },
                    // 
                    'sendyuncang': {
                        request: HttpPushFbb,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, node:0 }
                    },
                    'loadcost': {
                        request: HttpComuteCosts,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, node:0 }
                    },
                    'resetcost': {
                        request: HttpComuteCosts,
                        params: { orderIds: Array.isArray(id) ? id.join(',') : id, node:1 }
                    },
                    'submitabnormal': {
                        title: this.$t('erp.b2c.submit_abnormal',{defaultValue:'提交异常'}),
                        component: 'comAbnomal',
                        props: {
                            activeids: Array.isArray(id) ? id : [id]
                        }
                    },
                    'downorder': {
                        handleFunc: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/B2cOrder/download', { orderIds: Array.isArray(id) ? id.join(',') : id }, {
                                executor: 'request',
                                download: true,
                                fileName: "download.zip"
                            }).catch(err => {
                                this.$VMessage.error({
                                    content: err.message,
                                    duration: 30,
                                    closable: true
                                });
                            });
                        }
                    },
                    'changesendtime': {
                        title: this.$t('erp.distribution.change_lastest_send_time', { defaultValue: '修改最晚发货时间' }),
                        component: "compSendTime",
                        props: {
                            activeids: Array.isArray(id) ? id : [id]
                        }
                    }
                };
                return map[type];
            }
        }
    }
}